import { __rest, __assign } from 'tslib';
import { jsx, jsxs, Fragment } from '@emotion/react/jsx-runtime';
import { renderProp } from '../utils/renderProp.js';
import { useDropdown } from '../Dropdown/useDropdown.js';
import { useSelectable } from '../Selectable/useSelectable.js';
import { DropdownProvider } from '../Dropdown/DropdownProvider.js';
import { useUpdateEffect } from '../hooks/useUpdateEffect/index.js';
import { SelectableProvider } from '../Selectable/SelectableProvider.js';
import { SelectLegacyDropdownButton } from './SelectLegacyDropdownButton.js';
import { SelectLegacyDropdown } from './SelectLegacyDropdown.js';
import { SelectLegacyProvider } from './SelectLegacyProvider.js';
import { useSelectLegacy } from './useSelectLegacy.js';

var SelectLegacy = function (_a) {
    var dropdownZIndex = _a.dropdownZIndex, id = _a.id, _b = _a.look, look = _b === void 0 ? "dropdown" : _b, onChange = _a.onChange, onDismiss = _a.onDismiss, onSelectAction = _a.onSelectAction, multiple = _a.multiple, children = _a.children, defaultIsOpen = _a.defaultIsOpen, disabled = _a.disabled, _c = _a.invalid, invalid = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? "md" : _d, useSelectProps = __rest(_a, ["dropdownZIndex", "id", "look", "onChange", "onDismiss", "onSelectAction", "multiple", "children", "defaultIsOpen", "disabled", "invalid", "size"]);
    var dropdownContext = useDropdown({
        disabled: disabled,
        defaultIsOpen: defaultIsOpen,
        onDismiss: onDismiss,
    });
    var selectableContext = useSelectable(__assign({ id: id, onChange: function (value) {
            onChange === null || onChange === void 0 ? void 0 : onChange(value);
        }, onSelectAction: function (value) {
            onSelectAction === null || onSelectAction === void 0 ? void 0 : onSelectAction(value);
            if (!multiple) {
                if (!(value === null || value === void 0 ? void 0 : value.hasChildOptions)) {
                    dropdownContext.setIsOpen(false);
                    dropdownContext.triggerRef.current.focus();
                }
            }
        }, look: look, multiple: multiple, highlightSelected: !multiple, triggerRef: dropdownContext.triggerRef }, useSelectProps));
    useUpdateEffect(function () {
        selectableContext.setOptions(useSelectProps.options);
    }, [useSelectProps.options]);
    var selectContext = useSelectLegacy(__assign(__assign({}, selectableContext), useSelectProps));
    return (jsx(SelectableProvider, __assign({ value: selectableContext }, { children: jsx(SelectLegacyProvider, __assign({ value: selectContext }, { children: jsx(DropdownProvider, __assign({ value: dropdownContext }, { children: jsx("div", __assign({ ref: dropdownContext.dropdownRef, style: {
                        position: "relative",
                    } }, { children: jsx("div", __assign({ id: id, ref: selectContext.selectRef }, { children: renderProp({
                            prop: children,
                            context: selectContext,
                            fallback: (jsxs(Fragment, { children: [jsx(SelectLegacyDropdownButton, __assign({ invalid: invalid, size: size, "aria-invalid": invalid ? "true" : "false" }, (disabled && { "data-disabled": true }))), jsx(SelectLegacyDropdown, { sx: { zIndex: dropdownZIndex } })] })),
                        }) })) })) })) })) })));
};
SelectLegacy.displayName = "SelectLegacy";

export { SelectLegacy };
//# sourceMappingURL=SelectLegacy.js.map
